import { HttpClient } from 'packages/lib/api/rest-easy/http-client';
import {
  AnnotationsBackEndError,
  AnnotationsBackEndErrorSchema,
} from 'packages/lib/api/annotations/contract/error';
import { getDefaultHeaders } from 'packages/lib/api/rest-easy/utils';

export const annotationsClient = new HttpClient<AnnotationsBackEndError>({
  backend: 'annotations',
  errorSchema: AnnotationsBackEndErrorSchema,
  getDefaultHeaders,
  // HttpClient passes the raw body through when no schema variant matches, so `error` can be missing
  getErrorMessage: (payload) =>
    payload.error?.message ??
    'The annotations API returned an unrecognized error response',
  onResponseError: (error) => {
    console.log(error.message);
  },
});
